const MIGRATION_SERVICE = 'migration'

export default {
  namespaced: true,
  state: {},
  actions: {
    login ({ dispatch }, form) {
      return new Promise(function (resolve, reject) {
        return dispatch('API', MIGRATION_SERVICE, { root: true })
            .then(api => api.post('/', form))
            .then(response => resolve(response.data))
            .catch(err => reject(err))
      })
    },
    logout ({ dispatch }) {
      return new Promise(function (resolve, reject) {
        return dispatch('API', MIGRATION_SERVICE, { root: true })
            .then(api => api.delete('/'))
            .then(response => resolve(response.data))
            .catch(err => reject(err))
      })
    },
    account ({ dispatch }) {
      return new Promise(function (resolve, reject) {
        return dispatch('API', MIGRATION_SERVICE, { root: true })
            .then(api => api.get('/'))
            .then(response => resolve(response.data))
            .catch(err => reject(err))
      })
    },
    views ({ dispatch }, { all }) {
      return new Promise(function (resolve, reject) {
        return dispatch('API', MIGRATION_SERVICE, { root: true })
            .then(api => api.get('/views?all=' + encodeURIComponent(all)))
            .then(response => resolve(response.data))
            .catch(err => reject(err))
      })
    },
    migrateView ({ dispatch }, { view, all }) {
      return new Promise(function (resolve, reject) {
        return dispatch('API', MIGRATION_SERVICE, { root: true })
            .then(api => api.post('/views/' + encodeURIComponent(view.id) + '?all=' + encodeURIComponent(all), view))
            .then(response => resolve(response.data))
            .catch(err => reject(err))
      })
    },

    migrateMBF ({ dispatch }, number) {
      return new Promise(function (resolve, reject) {
        return dispatch('API', MIGRATION_SERVICE, { root: true })
          .then(api => api.post('/mbf', { number }))
          .then(response => resolve(response.data))
          .catch(err => reject(err))
      })
    },
  }
}
